"use strict";

var LoggerInstance = require("js-logger").get("SponsorshipApi");

var AbstractApi = require("./AbstractApi");
var ApiHelper = require("../shared/ApiHelper");

var SponsorshipApi = class extends AbstractApi {
	search(options) {
		options = options || {};
		return this.get({
			queryString: ApiHelper.deleteUndefinedValues({
				criteria: options.criteria,
				id: options.id,
				layoutId: options.layoutId,
				layoutName: options.layoutName,
				limit: options.limit,
				offset: options.offset,
				searchId: options.searchId,
				sponsorshipType: options.sponsorshipType
			}, /*includeNulls*/true),
			url: "/api/sponsorship/getresults"
		});
	}

	isAvailableForSponsorship(options) {
		options = options || {};
		return this.get({
			url: `/api/sponsorship/${options.sponsorshipCode}/isavailable`
		});
	}
};

module.exports = new SponsorshipApi();
